import React from 'react';
import './OneOnOneCard.scss';

const CARD_TEXT =
  "It's Giving Day! Buy today and Nas Academy will gift this course to someone in need.";

const OneOnOneCard = () => {
  const className = 'c-OneOnOneCard';

  return <div className={className}>{CARD_TEXT}</div>;
};

export default OneOnOneCard;
